import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import ParticipantCard from './ParticipantCard';
import CircularProgress from '@material-ui/core/CircularProgress';

export default class UserList extends Component {
  render() {
    const loader = (
      <div key={'loader'} className="loader">
        <CircularProgress />
      </div>
    );

    const { remountComponent, hasMoreItems, users, selectedUsers, className } = this.props;
    const { onUserClick, onLoadMoreItems } = this.props.events;

    const items =
      users &&
      users.length > 0 &&
      users.map(user => {
        const isSelected = selectedUsers.filter(u => user._id === u._id).length > 0 ? 'selected' : '';
        return <ParticipantCard key={user._id} user={user} handleOnUserClick={onUserClick} className={isSelected} />;
      });

    return (
      <div className={className} style={{ marginTop: '32px' }}>
        <InfiniteScroll
          pageStart={0}
          key={remountComponent}
          loadMore={onLoadMoreItems}
          hasMore={hasMoreItems}
          loader={loader}
          useWindow={false}
        >
          {items}
        </InfiniteScroll>
      </div>
    );
  }
}

UserList.propTypes = {
  users: PropTypes.array.isRequired,
  selectedUsers: PropTypes.array,
  hasMoreItems: PropTypes.bool,
  remountComponent: PropTypes.number,
  className: PropTypes.string,
  events: PropTypes.shape({
    onUserClick: PropTypes.func,
    onLoadMoreItems: PropTypes.func
  })
};

UserList.defaultProps = {
  users: [],
  selectedUsers: [],
  hasMoreItems: false,
  remountComponent: 1,
  className: '',
  events: {
    onLoadMoreItems: e => console.log('Event onLoadMoreItems', e),
    onUserClick: e => console.log('Event onUserClick', e)
  }
};
